import { createRouter, createWebHistory } from 'vue-router'
import { apiClient } from '@/services/api/client'

const baseUrl = (import.meta as { env?: { BASE_URL?: string } }).env?.BASE_URL ?? '/';
const AUTH_TOKEN_KEY = 'ppt_agent_access_token'
const AUTH_USER_KEY = 'ppt_agent_user'

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginView.vue'),
    },
    {
      path: '/upload',
      name: 'upload',
      component: () => import('@/views/UploadView.vue'),
    },
    {
      path: '/manual-create',
      name: 'manual-create',
      component: () => import('@/views/ManualCreateBootstrapView.vue'),
    },
    {
      path: '/theme-selection/:id',
      name: 'theme-selection',
      component: () => import('@/views/ThemeSelectionView.vue'),
    },
    {
      path: '/page-plan/:pagePlanId',
      redirect: to => ({
        name: 'page-plan-outline',
        params: { pagePlanId: to.params.pagePlanId },
      }),
    },
    {
      path: '/page-plan/:pagePlanId/outline',
      name: 'page-plan-outline',
      component: () => import('@/views/PagePlanOutlineView.vue'),
    },
    {
      path: '/page-plan/:pagePlanId/content',
      name: 'page-plan-content',
      component: () => import('@/views/PagePlanContentView.vue'),
    },
    {
      path: '/page-plan/:pagePlanId/design',
      name: 'page-plan-design',
      component: () => import('@/views/PagePlanDesignView.vue'),
    },
    {
      path: '/page-plan/:pagePlanId/overview',
      name: 'page-plan-overview',
      component: () => import('@/views/PagePlanOverviewView.vue'),
    },
    {
      path: '/reorg/:pagePlanId/framework',
      name: 'reorg-framework',
      redirect: to => ({
        name: 'page-plan-outline',
        params: { pagePlanId: to.params.pagePlanId },
      }),
    },
    {
      path: '/reorg/:pagePlanId/content',
      name: 'reorg-content',
      redirect: to => ({
        name: 'page-plan-content',
        params: { pagePlanId: to.params.pagePlanId },
      }),
    },
    {
      path: '/reorg/:pagePlanId/page-plan-entry',
      name: 'reorg-page-plan-entry',
      redirect: to => ({
        name: 'page-plan-design',
        params: { pagePlanId: to.params.pagePlanId },
      }),
    },
    {
      path: '/outline',
      name: 'outline',
      component: () => import('@/views/OutlineView.vue'),
    },
    {
      path: '/preview',
      name: 'preview',
      component: () => import('@/views/PreviewView.vue'),
    },
    {
      path: '/export',
      name: 'export',
      component: () => import('@/views/ExportView.vue'),
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('@/views/UserManagementView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/admin/usage',
      name: 'admin-usage',
      component: () => import('@/views/AdminUsageManagementView.vue'),
      meta: { requiresAdmin: true },
    },
    {
      path: '/usage',
      name: 'usage',
      component: () => import('@/views/MyUsageView.vue'),
    },
    {
      path: '/shares',
      name: 'shares',
      component: () => import('@/views/WorkflowSharesView.vue'),
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/HelpCenterView.vue'),
    },
    {
      path: '/editor/:documentId/:pageId',
      name: 'html-editor',
      component: () => import('@/views/HtmlEditorView.vue'),
    },
    {
      path: '/demo/outline-canvas',
      name: 'demo-outline-canvas',
      component: () => import('@/views/demo/OutlineCanvasPlaygroundView.vue'),
    },
  ],
})

router.beforeEach(async (to) => {
  if (to.path === '/login') {
    return true
  }
  const token = window.localStorage.getItem(AUTH_TOKEN_KEY)
  if (!token) {
    try {
      await apiClient.getMe()
      return true
    } catch {
      return { path: '/login', query: { redirect: to.fullPath } }
    }
  }

  if (to.meta?.requiresAdmin) {
    const rawUser = window.localStorage.getItem(AUTH_USER_KEY)
    if (rawUser) {
      try {
        const user = JSON.parse(rawUser) as { role?: string }
        if (String(user.role || '').toLowerCase() === 'admin') {
          return true
        }
      } catch {
        window.localStorage.removeItem(AUTH_USER_KEY)
      }
    }

    try {
      const me = await apiClient.getMe()
      if (String(me.role || '').toLowerCase() === 'admin') {
        return true
      }
    } catch {
      return { path: '/' }
    }
    return { path: '/' }
  }

  return true
})

export default router
